import type { SummaryResponse } from './types';

import { apiClient } from '~shared/api/createApiClient';

export const getSummary = (pharmacyId: string): Promise<SummaryResponse> => {
  return apiClient.get<SummaryResponse>('/api/summary', { pharmacyId });
};
